export default __webpack_public_path__ + "static/media/service2.94112157.png";